<!-- Table -->
<div class="table-responsive">
  <table class="table">
    <thead class="table-light">
      <tr class="d-flex d-md-table-row">
        <th scope="col" class="d-none d-md-table-cell" id="h-desc">
          {{ 'employeeModule.invoiceDescription' | translate }}
        </th>
        <th scope="col" class="col-3" id="h-hours-minutes">{{
          'employeeModule.hoursMinutes' | translate
        }}</th>
        <th scope="col" class="col-3 text-nowrap" id="h-rate">{{
          'employeeModule.hourlyRate' | translate
        }}</th>
        <th scope="col" class="col-3" id="h-vat">{{
          'employeeModule.vat' | translate
        }}</th>
        <th scope="col" class="col-3" id="h-total">{{
          'employeeModule.total' | translate
        }}</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let employeeBooking of contractEmployeeBookingsToBeInvoiced"
        class="d-flex flex-wrap d-md-table-row"
      >
        <th scope="row" class="d-block d-md-table-cell col-12" id="h-item">{{
          employeeBooking.description | replaceVarInString: ':01' : ':00'
        }}</th>
        <td class="col-3" headers="h-item h-hours-minutes">
          <span *ngIf="calculateHoursMinutes(employeeBooking).hours >= 1">
            {{ calculateHoursMinutes(employeeBooking).hours
            }}{{ 'general.hourAbbreviation' | translate }}
          </span>
          <span *ngIf="calculateHoursMinutes(employeeBooking).minutes >= 1">
            {{ calculateHoursMinutes(employeeBooking).minutes
            }}{{ 'general.minuteAbbreviation' | translate | lowercase }}
          </span>
        </td>
        <td class="text-nowrap col-3" headers="h-item h-rate">
          {{
            (calculateSalary(employeeBooking, contract) | async)
              ? (calculateSalary(employeeBooking, contract) | async | currency)
              : '-'
          }}
        </td>
        <td class="col-3" headers="h-item h-vat"
          >{{ contract?.vat ? contract.vat : 0 }}%</td
        >

        <td class="text-end text-nowrap col-3" headers="h-item h-total">
          {{
            getItemTotal(
              employeeBooking.durationInMinutes,
              calculateSalary(employeeBooking, contract) | async,
              contract.vat
            ) | currency
          }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
<!-- End Table -->

<hr class="my-5" />

<div
  class="row justify-content-md-end mb-3"
  *ngIf="contractEmployeeBookingsToBeInvoiced"
>
  <ng-container
    *ngIf="
      calculateTotals(contractEmployeeBookingsToBeInvoiced) | async as totals
    "
  >
    <div class="col-md-8 col-lg-6">
      <dl class="row text-sm-end">
        <dt class="col-6">{{ 'employeeModule.subtotal' | translate }}:</dt>
        <dd class="col-6"> {{ totals.subTotal | currency }} </dd>
      </dl>

      <dl class="row text-sm-end">
        <dt class="col-6">{{ 'employeeModule.exVat' | translate }}:</dt>
        <dd class="col-6">
          {{ totals.subTotal | currency }}
        </dd>
      </dl>

      <dl class="row text-sm-end">
        <dt class="col-6">
          {{ 'employeeModule.vat' | translate }}:
          {{ contract?.vat ? contract.vat : 0 }}%
        </dt>
        <dd class="col-6">
          {{ totals['vat'] | currency }}
        </dd>
      </dl>

      <dl class="row text-sm-end">
        <dt class="col-6">{{ 'employeeModule.inclVat' | translate }}:</dt>
        <dd class="col-6">
          {{ totals['inclVat'] | currency }}
        </dd>
      </dl>
    </div>
  </ng-container>
</div>
<!-- End Row -->
